module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8004.bfd854c9.png";